module.exports = __webpack_public_path__ + "media/images/edion/top/9-ea917e97ae8e6678d88556e4a71195f5.png";